import React from 'react'


const Email = props => {
    return<>
          <p>thds****y**n@fmail.com</p>
     </>
}



export default Email;